import React, { Component } from 'react';
import AddComment from './addComment';
import Comment from './comment';

class ListingModalComments extends Component {

    render() {
        const { listing, myProfile, comments, hideAddComment = false } = this.props;

        var commentsRender = [];
        if (comments && comments.length > 0) {
            // Sort Descending
            comments.sort((a, b) => new Date(a.CommentDate) - new Date(b.CommentDate))
                .map((cmt, i) => {
                    commentsRender.push(
                        <Comment key={i} comment={cmt} isModal={true}
                            myProfile={myProfile}
                            onUpdateComment={this.props.onUpdateComment}
                            onDeleteComment={this.props.onDeleteComment}
                            userPhotoList={this.props.userPhotoList} />
                    );
                    return <div />;
                });
        }
        else
            commentsRender.push(<div className="activity_comment" key="no-comments">No Comments</div>);

        if (!hideAddComment)
            commentsRender.push(
                <AddComment key="cmt_add" id={listing.ActivityId} propertyId={listing.Id} myProfile={myProfile}
                    showNotification={this.props.showNotification}
                    onAddComment={this.props.onAddComment}
                    className="bottom_fix" />
            );

        return (
            <div>
                {commentsRender}
            </div>
        )
    }
}

export default ListingModalComments;